import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { HelmetProvider } from "react-helmet-async";
import { installNetworkErrorInterceptor } from "@/lib/networkErrorInterceptor";

// Install the axios network-error interceptor BEFORE React mounts so that
// any request fired during initial render gets the [NET-DEBUG] tagging
// and Species-1-vs-real-CORS classification. See the file for triage doc.
installNetworkErrorInterceptor();

// Capture the PWA install prompt as early as possible — before React mounts.
// The `beforeinstallprompt` event fires once per session, often before useEffect
// listeners are attached. Storing it globally lets usePWAInstall pick it up on
// any page regardless of which page the user first loaded.
window.__pwaInstallPrompt = null;
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  window.__pwaInstallPrompt = e;
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
);

// ─── Service Worker Registration ─────────────────────────────────────────────
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((reg) => {
        console.log("[SW] Registered, scope:", reg.scope);
        // Poll for updates every 60 seconds while the app is open
        setInterval(() => reg.update(), 60 * 1000);
      })
      .catch((err) => {
        console.warn("[SW] Registration failed:", err);
      });
  });
}
